export const TABLES_KEYS = {
  universitiesTable: 'universities',
  hostCompaniesTable: 'hostCompanies',
  placementTable: 'plat',
  participantTable: 'part',
  allParticipantsTable: 'allPart',
  staffTable: 'staf',
  partnerTable: 'partner',
  leadsTable: 'leads',
  followUpsUnresolvedTable: 'leadFollowUpsUnresolved',
  followUpsResolvedTable: 'leadFollowUpsResolved',
  assignedPlacementTable: 'asst',
  appliedPlacementTable: 'appt',
  interestedPlacementTable: 'intt',
  myPlacementTable: 'mypt',
  invoiceTable: 'invoice',
  paymentTable: 'payment',
  receiptTable: 'receipt',
  productTable: 'product',
  tasksTable: 'tasks',
  participantsApprovedPlacementsTable: 'partApprovPlat',
  participantsRejectedPlacementsTable: 'partRejecPlat',
  participantsPendingPlacementsTable: 'partPendPlat',
  participantsOthersPlacementsTable: 'partOtherPlat',
  programsTable: 'program',
  myTasksTable: 'myTasks',
  paymentInvoiceTable: 'paymentInvoice',
  rolesTable: 'roles',
  reminderLogsTable: 'rdfr',
  upcomingRemindersTable: 'urm',
  automatedReminderLogsTable: 'arlg',
  bulkRemindersTable: 'brk',
  bulkReminderLogsDialogTable: 'brld',
  reminderTemplatesTable: 'rtlTmpl',
  announcementsTable: 'announcements',
};
